export const APIUrl = {
  login: "/user/login",
  forgotPassword: "/user/forgot-password",
  signup: "/user/signup",
  verifyOTP: "/user/verify-otp",
  resendOTP: "/user/resend-otp",
  updatePassword: "/user/update-password",
  allBusiness: "/business",
  businesses: (userId: string) => `/user/${userId}/business`,
  user: (userId: string) => `/user/${userId}`,
  business: (userId: string, businessId: string) =>
    `/user/${userId}/business/${businessId}`,
  campaignsReport: "/user/campaign/trackier-report",
  users: "/user",
  allCampaigns: "/campaign",
  searchApp: "/app/search",
  apps: (userId: string) => `/user/${userId}/app`,
  manulApps: (userId: string) => `/user/${userId}/manul-app`,
  allApps: "/app",
  app: (userId: string, appId: string) => `/user/${userId}/app/${appId}`,
  brand: "/brand",
  androidVersion: "/os-version/android",
  iosVersion: "/os-version/ios",
  language: "/language",
  ageGroup: "/age-group",
  interest: "/interest",
  countries: "/countries",
  states: (country: string) => `/states/${country}`,
  campaigns: (userId: string, campaign?: string) =>
    `/user/${userId}/campaign${campaign ? `/${campaign}` : ""}`,
  campaignsStatus: (userId: string, campaign: string, status: string) =>
    `/user/${userId}/campaign/${campaign}/${status}`,
  trackier: (userId: string, campaign: string) =>
    `/user/${userId}/campaign/${campaign}/trackier`,
  aggregateReport: (userId: string) => `/user/${userId}/aggregate-report`,

  // AdminLogin: "/admin/login",
  // Logout: "/admin/logout",
  // ReclaimLogin: "/login/reclaim",
  // Setting: "/setting",
  // Business: "/user/{userId}/business/{businessId}",
  // Campaign: "/user/{userId}/campaign/{campaignId}",
  // RequestReport: "/user/{userId}/campaign/{campaignId}/request-report",
  // AddReport: "/user/{userId}/campaign/{campaignId}/report",
  // ChangePasword: "/user/{userId}/change-password",
  // ResetPasword: (userId: string) => `/user/${userId}/passwod/reset`,
};
